import { lazy } from 'react';

// ----------------------------------------------------------------------

const EmployeeDetailsPage = lazy(() => import('../pages/EmployeeDetails.page'));
const EmployeesPage = lazy(() => import('../pages/Employees.page'));
const AddEmployeePage = lazy(() => import('../pages/AddEmployee.page'));
const EditEmployeePage = lazy(() => import('../pages/EditEmployee.page'));

// ----------------------------------------------------------------------

const HumanResourcesRoutes = [
    {
        path: '/human-resources',
        children: [
            { path: 'employees', element: <EmployeesPage />, layout: 'default', isAuthReq: true },
            { path: 'add-employee', element: <AddEmployeePage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id', element: <EmployeeDetailsPage />, layout: 'default', isAuthReq: true },
            { path: 'employee/:id/edit', element: <EditEmployeePage />, layout: 'default', isAuthReq: true },
        ],
    },
];

export { HumanResourcesRoutes };
